<template>
    <div id="box">
      <img src="../assets/loading.gif" style="width: 500px;height: 390px;" alt="">
      <p class="tipsText">正在进入直播间请稍等...</p>
    </div>
  </template>
  <script>
  import { getUserInfoAjax, getUserSig, getStuUserInfo } from "@/utils/getData.js";
  import { setCookie, getCookie } from '@/utils/cookie.js'
  export default {
    components: {},
    data() {
      return {};
    },
    computed: {},
    watch: {},
    methods: {
      // 获取地址栏信息
      getUrlSearch(name) {
        if (!name) return null;
        var after = window.location.search;
        after = after.substr(1) || window.location.hash.split("?")[1];
        if (!after) return null;
        if (after.indexOf(name) === -1) return null;
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURI(after).match(reg);
        if (!r) return null;
        return r[2];
      },
    },
    created() {
      let _this = this;
      setCookie('roomToken', this.getUrlSearch("t"))
      // setCookie('roleType', this.getUrlSearch("type"))
      this.$store.commit('roleTypeMutations',this.getUrlSearch("type"))
      setCookie('groupId', this.getUrlSearch("groupId"))
      getUserSig().then((res) => {
        if (res.code == 200) {
          setCookie('userSig', res.data)
          var userType = this.getUrlSearch("userType")
          getUserInfoAjax({ groupId: this.getUrlSearch("groupId"),userType: userType}).then(user => {
            if (res.code == 200) {
              setCookie('userInfo', JSON.stringify(user.data))
              setCookie('roomId', user.data.roomId)
              _this.$router.push({ path: "/room" });
            }else if(res.code == 401){
              _this.$alert('您的登录已过期请重新登录!', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  window.open(process.env.VUE_APP_SUPERIOR_URL,'_blank')
                  window.close()
                }
              });
            }
          })
        }
      });
    },
  };
  </script>
  <style lang='scss' scoped>
  //@import ''; 引入公共css类
  #box {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .tipsText {
      font-size: 32px;
      color: #dea1e5;
    }
  }
  </style>